import { render, staticRenderFns } from "./VTcalendar.vue?vue&type=template&id=38e6bfc3&scoped=true&"
import script from "./VTcalendar.vue?vue&type=script&lang=js&"
export * from "./VTcalendar.vue?vue&type=script&lang=js&"
import style0 from "./VTcalendar.vue?vue&type=style&index=0&id=38e6bfc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e6bfc3",
  null
  
)

export default component.exports